import { render, staticRenderFns } from "./DashboardWidgetNewsletterSubscriptions.vue?vue&type=template&id=a804b0c6&scoped=true"
import script from "./DashboardWidgetNewsletterSubscriptions.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetNewsletterSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804b0c6",
  null
  
)

export default component.exports